input,
select,
textarea {
  padding: 0;
  margin: 0;
  background-color: unset;
  border: unset;
  color: unset;
  font: unset;
  outline: unset;
}

:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  display: flex;
  align-items: center;
}

.navList,
li {
  display: contents;
}

.go-to {
  grid-area: go-to;
}

.pages {
  align-items: center;
  display: flex;
  grid-area: pages;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.navigation-info {
  grid-area: navigation-info;
}

.items-per-page {
  display: flex;
  grid-area: items-per-page;
}

.items-per-page-info {
  grid-area: items-per-page-info;
}

.first-button {
  grid-area: first__button;
}

.last-button {
  grid-area: last__button;
}

.next-button {
  grid-area: next__button;
}

.prev-button {
  grid-area: prev__button;
}